import { SpotlightFormSchema } from "@redotech/redo-spotlight-common/spotlight-schema";
import { WidgetAutocheck } from "@redotech/redo-storefront-widget-common/widget";
import { DEFAULT_REDO_OVERLAY_Z_INDEX } from "@redotech/redo-web/shopify/shopify-z-index";
import { createRoot } from "react-dom/client";
import { RedoShopifyRpcClientContextProvider } from "../client/redo-shopify-rpc-client";
import { RedoStorefrontContainer } from "../redo-storefront/redo-storefront-container";
import "../styles.css";
import { SpotlightInstanceWrapper } from "./spotlight-instance-wrapper";

const REDO_SPOTLIGHT_CONTAINER_ID = "redo-spotlight-container";

export function initialize(autocheck: WidgetAutocheck) {
  if (globalThis.blockRedo) {
    return;
  }

  if (document.getElementById(REDO_SPOTLIGHT_CONTAINER_ID)) {
    return;
  }

  const redoContainer = document.createElement("div");
  redoContainer.id = REDO_SPOTLIGHT_CONTAINER_ID;
  redoContainer.style.zIndex = `${DEFAULT_REDO_OVERLAY_Z_INDEX}`;
  redoContainer.style.display = "block";
  document.body.append(redoContainer);

  const root = createRoot(redoContainer);

  const queryParameters = new URLSearchParams(location.search);
  const forceId = queryParameters.get("spotlight-id") || undefined;
  const parsedForceSpotlight = (() => {
    const forceSpotlight = queryParameters.get("spotlight-object") || undefined;

    const forcedSpotlightParseResult = forceSpotlight
      ? SpotlightFormSchema.safeParse(JSON.parse(forceSpotlight))
      : undefined;
    if (forcedSpotlightParseResult && !forcedSpotlightParseResult?.success) {
      console.error(
        "Failed to parse forced spotlight",
        forcedSpotlightParseResult.error,
      );
    }
    return forcedSpotlightParseResult?.success
      ? forcedSpotlightParseResult.data
      : undefined;
  })();

  root.render(
    <RedoStorefrontContainer container={redoContainer}>
      <RedoShopifyRpcClientContextProvider
        baseUrl={
          globalThis.redoStorefront?.env?.REDO_SHOPIFY_SERVER_URL ??
          process.env.REDO_SHOPIFY_SERVER_URL!
        }
        storeUrl={
          globalThis.redoStorefront?.storeUrl ??
          globalThis.Shopify?.shop ??
          globalThis.Shopify?.Checkout?.apiHost
        }
        widgetId={globalThis.redoWidgetId}
      >
        <SpotlightInstanceWrapper
          autocheck={autocheck}
          forceId={forceId}
          forceSpotlight={parsedForceSpotlight}
        />
      </RedoShopifyRpcClientContextProvider>
    </RedoStorefrontContainer>,
  );
}
